// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const headers = (accessToken: string) => ({
  headers: { Authorization: `Bearer ${accessToken}` },
});

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const primeAuthHeaders = (accessToken?: string | null) => ({
  headers: { Authorization: `Bearer ${accessToken}`, 'Auth-Secondary': 'true', 'X-Okta-Authorization': 'true' },
});
